import { createRouter, createWebHistory } from 'vue-router';
import UserLogin from '../components/UserLogin.vue';


const routes = [  
  {
    path: '/',
    redirect: '/UserLogin' // 默认登录页面
  },
  {
    path: '/UserLogin',
    component: UserLogin
  },


 // 成果检索查询
 {
  path: '/projectSearch',
  component: () => import('@/components/ProjectSearch')
 },

  // 成果检索列表
  {
    path: '/projectList',
    component: () => import('@/components/ProjectList')
  },
  // 成果检索列表点击查看详情
  {
    path: '/projectListDetail',
    component: () => import('@/components/ProjectListDetail')
  },
  // 政策标准--国家标准---列表
  {
    path: '/policyList',
    component: () => import('@/components/PolicyList')
  },

  // 政策标准--国家标准---评价标准---查看详细内容
  {
    path: '/PolicyDetail',
    component: () => import('@/components/PolicyDetail')
  },
   //专家列表
  {
    path: '/exportList',
    component: () => import('@/components/ExportList')
  },

   //专家详细内容
  {
    path: '/exportDetail',
    component: () => import('@/components/ExportDetail')
  },
  // 首页详细内容
  {
    path: '/contextDetail',
    component: () => import('@/components/ContextDetail')
  },
  //项目评价
  {
    path: '/projectEvaluation',
    component: () => import('@/components/ProjecteValuation')
  },
  // //科技查新
  // {
  //   path: '/projecteNewApply',
  //   component: () => import('@/components/ProjecteNewApply')
  // },

   //科技查新
   {
    path: '/projecteNewApply',
    component: () => import('@/components/ProjecteNewApplyTwo')
  },
  //打开pdf文件
  // {
  //   path: '/pdfDetail',
  //   component: () => import('@/components/PdfDetail')
  // },
  // {
  //   path: '/tbAssessmentExportFinalCheck',
  //   name: 'TbAssessmentExportFinalCheck',
  //   component: () => import('@/views/modules/assessmentreportmanage/modules/TbAssessmentExportFinalCheck')
  // },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
